module.exports = "<p>\n  payment works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/payment/payment.component.html
// module id = ./src/app/Dashboard/DashboardPages/System settings/payment/payment.component.html
// module chunks = main